import {EFilterValueType} from 'features/predicate-expression-form-list'

export enum EReportConfigurationTabKey {
    REPORT_CONFIGURATOR = 'reportConfigurator',
    REPORT_TABLE_OF_CONTENTS = 'reportTableOfContents',
    REPORT_PROPERTIES_SETTINGS = 'reportPropertiesSettings',
    REPORT_TABLE_SETTINGS = 'reportTableSettings',
    REPORT_HEADER_SETTINGS = 'reportHeaderSettings',
    REPORT_DD_REFERENCES = 'reportDdReferences',
    REPORT_DD_FILTERS = 'reportDdFilters',
    REPORT_DD_PARAMETERS = 'reportDdParameters',
    REPORT_DD_RESTRICTIONS = 'reportDdRestrictions',
    REPORT_COMPARISON = 'reportComparison',
    REPORT_KS_SETTINGS = 'reportKSSettings',
    REPORT_DOWNLOAD_SETTINGS ='reportDownloadSettings',
}

export enum EReportConfigurationFormName {
    CONFIGURATOR = 'configurator',
    PROPERTIES_SETTINGS = 'propertiesSettings',
    TABLE_SETTINGS = 'tableSettings',
    SORTING_SETTINGS = 'sortingSettings',
    GROUPING_SETTINGS = 'groupingSettings',
    FORMAT_SETTINGS = 'formatSettings',
    REPORT_MENU = 'reportMenu',
    HEADER_SETTINGS = 'headerSettings',
    RESERVED_COLUMNS_SETTINGS = 'reservedColumns',
    REPORT_COMPARISON = 'reportComparisons',
    REPORT_KS_SETTINGS = 'crColumns',
    REPORT_DOWNLOAD_SETTINGS = 'exportTo',
    EXCEL_TABLE_HEADER_STRUCTURE_LOADER = 'excelTableHeaderStructure',
}

export const reportConfigurationFormTitles = {
    [EReportConfigurationFormName.CONFIGURATOR]: 'Конфигуратор отчета',
    [EReportConfigurationFormName.TABLE_SETTINGS]: 'Настройка табличной части',
    [EReportConfigurationFormName.FORMAT_SETTINGS]: 'Правила форматирования',
    [EReportConfigurationFormName.SORTING_SETTINGS]: 'Настройки сортировки',
    [EReportConfigurationFormName.GROUPING_SETTINGS]: 'Настройки группировки',
    [EReportConfigurationFormName.REPORT_MENU]: 'Настройка оглавления',
    [EReportConfigurationFormName.HEADER_SETTINGS]: 'Настройка заголовка отчёта',
    [EReportConfigurationFormName.RESERVED_COLUMNS_SETTINGS]: 'Настройка служебных столбцов',
    [EReportConfigurationFormName.PROPERTIES_SETTINGS]: 'Настройка параметров отчета',
    [EReportConfigurationFormName.REPORT_KS_SETTINGS]: 'Настройка КС',
    [EReportConfigurationFormName.REPORT_COMPARISON]: 'Настройка сравнения',
    [EReportConfigurationFormName.REPORT_DOWNLOAD_SETTINGS]: 'Настройка скачивания',
    [EReportConfigurationFormName.EXCEL_TABLE_HEADER_STRUCTURE_LOADER]: 'Настройка шапки табличной части через Excel',
} as const;

export const REPORT_CONFIGURATION_NAME = 'administration.report.configuration';
export const PROPERTY_SETTINGS_ENTITY_NAME = 'administration.property';
export const SVC_RISK_ENTITY_NAME = 'analysis2.org.risk';
export enum ETypeGroup {
    OTHER = 'OTHER',
    NUMBER = 'NUMBER',
    DATE = 'DATE',
}

export const ReportConfigurationNotNullableFormNames = [
    EReportConfigurationFormName.REPORT_COMPARISON,
    EReportConfigurationFormName.REPORT_KS_SETTINGS,
];

export const URL_TABLE_REPORT_MENU_ITEMS = '/valueLists/TABLE_REPORT_MENU_ITEMS_UNIQUE';

export type TReportTableColumnFunction = 'url' | 'dd';

export const DRILLDOWN_ID_PARAM_KEY = 'drillDownId';

// === Фильтрация внутри отчётов ===

export enum EFilterConditionsLookupSegmentValueKeys {
    enabledForNumeric = 'enabled_for_numeric',
    enabledForDate = 'enabled_for_date',
    enabledForText = 'enabled_for_text'
}

export const FilterValueToDffSegmentMapping = {
    [EFilterValueType.date]: EFilterConditionsLookupSegmentValueKeys.enabledForDate,
    [EFilterValueType.number]: EFilterConditionsLookupSegmentValueKeys.enabledForNumeric,
    [EFilterValueType.text]: EFilterConditionsLookupSegmentValueKeys.enabledForText,
};
